var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#DBD1F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C10.3966 6 9.09677 7.22259 9.09677 8.73074C9.09677 10.2389 10.3966 11.4615 12 11.4615C13.6034 11.4615 14.9032 10.2389 14.9032 8.73074C14.9032 7.22259 13.6034 6 12 6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90323 12.9179C7.29982 12.9179 6 14.1405 6 15.6486V16.5139C6 17.4 6.9 17.8388 7.2 18C10.7019 19.8815 13.8404 19.8815 17.1 18C17.2262 17.9272 18 17.4 18 16.5139V15.6486C18 14.1405 16.7002 12.9179 15.0968 12.9179H14.8329C14.69 12.9179 14.5481 12.9391 14.4123 12.9808L13.7423 13.1866C12.6102 13.5343 11.3898 13.5343 10.2577 13.1866L9.58767 12.9808C9.45189 12.9391 9.30996 12.9179 9.16712 12.9179H8.90323Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/DefaultAvatar.110c9464d2287a8083b959d8bad60011.svg";
export { ForwardRef as ReactComponent };